// extracted by mini-css-extract-plugin
export default {"container":"tabs_container__kHBli","tab":"tabs_tab__p2cc6","active":"tabs_active__3ByEn"};